import Icon from '../components/Icon.vue'

Icon.register({"chart-area":{"width":512,"height":512,"paths":[{"d":"M500 384C506.6 384 512 389.4 512 396V436C512 442.6 506.6 448 500 448H12C5.4 448 0 442.6 0 436V76C0 69.4 5.4 64 12 64H52C58.6 64 64 69.4 64 76V384H500zM372.7 159.5L288 216 202.7 102.3C197.6 95.5 187.2 96 182.8 103.3L96 248V352H480L390.1 164.2C386.9 157.7 378.7 155.5 372.7 159.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/chart-area.js
// module id = null
// module chunks = 